import { gql } from '@/shared/graphql/generated/cache';

export const getPendingDeposits = gql(/* GraphQL */ `
  query getPendingDeposits($address: String!, $chain: String!, $asset: String!) {
    pendingDeposits(input: { address: $address, chain: $chain, asset: $asset }) {
      amount
      txRef
    }
  }
`);
